export const NAMESPACE = 'auth'

export const ORGANIZATIONS_LIST = [
  {label: 'wingu', value: 'wingu'},
  {label: 'donar online', value: 'donar_online'},
  {label: 'kubadili', value: 'kubadili'},
  {label: 'techo', value: 'techo'},
]